import React from 'react';
import styled from 'styled-components';

/**
 * Small brand-colour marks so a payment section reads as payments at a glance
 * (Ray 2026-10-27: "it looks like a normal form"). Drawn, not downloaded.
 */
export type PayKind = 'gcash' | 'maya' | 'bank';

export const PayLogo = ({ kind, size = 28 }: { kind: PayKind; size?: number }) =>
   kind === 'bank' ? (
      <Mark $bg="#1f2a44" $size={size} aria-label="Bank" title="Bank transfer">
         🏦
      </Mark>
   ) : kind === 'maya' ? (
      <Mark $bg="#00b464" $size={size} aria-label="Maya" title="Maya">
         <Word $size={size}>maya</Word>
      </Mark>
   ) : (
      <Mark $bg="#0070e0" $size={size} aria-label="GCash" title="GCash">
         <Word $size={size} $bold>G</Word>
      </Mark>
   );

/** GCash · Maya · Bank in a row — e.g. on the empty state. */
export const PayLogoRow = ({ size = 34 }: { size?: number }) => (
   <Row>
      <PayLogo kind="gcash" size={size} />
      <PayLogo kind="maya" size={size} />
      <PayLogo kind="bank" size={size} />
   </Row>
);

const Mark = styled.span<{ $bg: string; $size: number }>`
   display: inline-grid;
   place-items: center;
   flex-shrink: 0;
   width: ${({ $size }) => $size}px;
   height: ${({ $size }) => $size}px;
   border-radius: ${({ $size }) => Math.round($size * 0.28)}px;
   background: ${({ $bg }) => $bg};
   color: #fff;
   font-size: ${({ $size }) => Math.round($size * 0.5)}px;
   line-height: 1;
`;
const Word = styled.span<{ $size: number; $bold?: boolean }>`
   font-family: Arial, Helvetica, sans-serif;
   font-weight: 800;
   letter-spacing: ${({ $bold }) => ($bold ? '0' : '-0.02em')};
   font-size: ${({ $size, $bold }) => Math.round($size * ($bold ? 0.6 : 0.32))}px;
`;
const Row = styled.span`
   display: inline-flex;
   gap: 8px;
   align-items: center;
`;
